import React from 'react';

const GettingStarted = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Getting Started</h1>
      
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
        <p className="text-sm text-blue-800">
          This guide will help you set up your account and start finding business leads.
        </p>
      </div>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3 w-full">Account Types</h2>
        <p className="text-gray-700 mb-3 text-left">
          You can create an account in three ways:
        </p>
        <ul className="list-disc pl-5 space-y-2 text-gray-700 flex flex-col items-start text-left">
          <li><strong>Email & Password:</strong> Standard account creation with email verification required</li>
          <li><strong>Google Sign-In:</strong> Quick setup using your Google account (no verification needed)</li>
          <li><strong>Guest Mode:</strong> Try the app immediately without registration (data lost on logout)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">Email Verification</h2>
        <p className="text-gray-700 mb-3 text-left">
          If you signed up with email, you'll need to verify your email address before full access.
        </p>
        <ol className="list-decimal pl-5 space-y-2 text-gray-700 flex flex-col items-start text-left">
          <li>Check your inbox for the verification email</li>
          <li>Click the verification link</li>
          <li>Return to the app - you'll be automatically redirected</li>
        </ol>
        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-3 mt-3">
          <p className="text-sm text-yellow-800">
            <strong>Note:</strong> Check your spam folder if you don't see the email within a few minutes.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">Upgrading Guest Accounts</h2>
        <p className="text-gray-700 mb-3 text-left">
          Started as a guest? Upgrade to save your data permanently.
        </p>
        <ol className="list-decimal pl-5 space-y-2 text-gray-700 flex flex-col items-start text-left">
          <li>Click "Upgrade Account" on the login page or dashboard banner</li>
          <li>Choose email/password or Google sign-in</li>
          <li>Your guest data will be transferred to your permanent account</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">API Request Limits</h2>
        <p className="text-gray-700 mb-3 text-left">
          Your account has a daily limit on search requests based on your account type. You can monitor your remaining requests in the search interface.
        </p>
        <div className="bg-gray-50 border border-gray-200 rounded p-4">
          <ul className="space-y-1 text-sm text-gray-700">
            <li>• Each search circle consumes one request</li>
            <li>• Upgrade your account for higher limits</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-3">Quick Start Workflow</h2>
        <ol className="list-decimal pl-5 space-y-3 text-gray-700 flex flex-col items-start text-left">
          <li>
            <strong>Search for businesses</strong> - Add circles on the map or draw custom shapes
          </li>
          <li>
            <strong>Filter results</strong> - Include/exclude business types to refine your search
          </li>
          <li>
            <strong>Save places</strong> - Review results and save relevant businesses
          </li>
          <li>
            <strong>Enrich with data</strong> - Use crawling features to find social media links
          </li>
          <li>
            <strong>Export leads</strong> - Download your leads as CSV for outreach
          </li>
        </ol>
      </section>
    </div>
  );
};

export default GettingStarted;